// Pseudo-year bucket names for Teacher Management's filter (a teacher with
// no class/year coverage - admin, IT access, or no role at all). Kept in
// their own module, separate from TeacherManagement.js, so ManagementHome
// can import them without defeating that component's React.lazy() code
// splitting.
export const ADMIN_BUCKET = 'Admin'
export const IT_ACCESS_BUCKET = 'IT Access'
export const NO_ROLE_BUCKET = 'No role'
